import React from 'react';
import type { Account, User } from '@axiom/validation';
import {
  Card,
  CardFooter,
  ClientEngagementNoTalentCardSection,
} from '@axiom/ui';

import { StartEngagementButton } from '../StartEngagementButton/StartEngagementButton';

export type ClientEngagementNoTalentCardProps = {
  account?: Account;
  user?: User | null;
  onLoggedOutSubmissionClick?: () => void;
};

export const ClientEngagementNoTalentCard = ({
  account,
  user,
  onLoggedOutSubmissionClick,
}: ClientEngagementNoTalentCardProps) => {
  return (
    <Card name="no-profiles">
      <ClientEngagementNoTalentCardSection />
      <CardFooter>
        <StartEngagementButton
          name="NEW_ENGAGEMENTS_BUTTON"
          account={account}
          user={user}
          pattern="primary"
          variation="filled"
          onLoggedOutSubmissionClick={onLoggedOutSubmissionClick}
        >
          Start a new engagement
        </StartEngagementButton>
      </CardFooter>
    </Card>
  );
};
